import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class NotesService {


  static getNote(item) {

    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

    let api = `${API_BASE_URL}${dynamicPaths.getNote}`;
    const params = new URLSearchParams();

    if (item?.limit) params.append("limit", item.limit);
    if (item?.page) params.append("page", item.page);
    if (item?.id) params.append("id", item.id);
    if (item?.standardId) params.append("standardId", item.standardId);
    if (item?.sectionId) params.append("sectionId", item.sectionId);
    if (item?.subjectId) params.append("subjectId", item.subjectId);
    if (item?.teacherId) params.append("teacherId", item.teacherId);
    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }
    return axiosInstance
      .get(api, item)
  }



  static addNote(data) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.addNote}`;
    return axiosInstance
      .post(api, data)
  }

  static updateNote(data) {

    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.editNote}`;
    return axiosInstance
      .put(api, data)

  }
  static deleteNote(id) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.deleteNote}?id=${id}`;

    return axiosInstance
      .delete(api)
  }


}

export default NotesService;
